import { useNavigate } from 'react-router';

export function useViewTransitionNavigate() {
  const navigate = useNavigate();

  return (url, options) => {
    if (document.startViewTransition) {
      document.startViewTransition(() => navigate(url, options));
    } else {
      navigate(url, options);
    }
  };
}
